import { getApp, getApps, initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import {
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  setPersistence,
} from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { setAppCheck } from './appCheck';
import { env, isDev } from './env';

declare global {
  // eslint-disable-next-line no-var
  var FIREBASE_APPCHECK_DEBUG_TOKEN: string | boolean | undefined;
}

const app = getApps().length
  ? getApp()
  : initializeApp({
      apiKey: env.VITE_FIREBASE_API_KEY,
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: env.VITE_FIREBASE_APP_ID,
    });

/*
 * App Check must be installed before any other Firebase call so tokens are
 * attached to the very first request. In development we register the debug
 * token instead of hitting reCAPTCHA.
 */
if (env.VITE_APPCHECK_DEBUG_TOKEN && isDev) {
  globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = env.VITE_APPCHECK_DEBUG_TOKEN;
}

if (env.VITE_RECAPTCHA_SITE_KEY) {
  setAppCheck(
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(env.VITE_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    }),
  );
} else if (!isDev) {
  // A production build without App Check is a configuration error, not a
  // silent degradation.
  console.error('App Check is not configured: VITE_RECAPTCHA_SITE_KEY is missing.');
}

export const firebaseApp = app;
export const auth = getAuth(app);
export const db = getFirestore(app);

// Sender sessions survive a reload; the viewer's anonymous session does not
// need to, but the same persistence keeps behaviour predictable.
void setPersistence(auth, browserLocalPersistence);

if (env.VITE_USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}
